import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BonusSection } from '../components/BonusSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
    // Set page title and meta tags for sharing
    document.title = 'Mil Hojas Pro — Domina la Técnica del Hojaldre Perfecto';
    // Meta description
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Descubre el secreto del "Escudo de Cristal" y logra un Mil Hojas 100% crujiente. Guía paso a paso + bonos exclusivos.';
    // Open Graph tags for social sharing
    const ogTags: Record<string, string> = {
      'og:title': 'Mil Hojas Pro — Domina la Técnica del Hojaldre Perfecto',
      'og:description': 'Descubre el secreto del "Escudo de Cristal" y logra un Mil Hojas 100% crujiente.',
      'og:type': 'website',
      'og:image': 'https://cdn.magicpatterns.com/uploads/tw6KWHMb7t51djdwgghJH6/portada.png'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  return <div className="min-h-screen bg-white font-sans text-stone-900" data-id="element-464">
      <nav className="bg-white border-b border-stone-100 py-4 sticky top-0 z-50" data-id="element-465">
        <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-466">
          <span className="font-serif font-bold text-xl text-stone-900 tracking-tight" data-id="element-467">
            Mil Hojas <span className="text-amber-600" data-id="element-468">Pro</span>
          </span>
        </div>
      </nav>

      <main data-id="element-469">
        <HeroSection data-id="element-470" />
        <ProblemSection data-id="element-471" />
        <SolutionSection data-id="element-472" />
        <BenefitsSection data-id="element-473" />
        <TestimonialsSection data-id="element-474" />
        <BonusSection data-id="element-475" />
        <OfferSection data-id="element-476" />
      </main>

      <Footer data-id="element-477" />
      <RecentPurchaseToast data-id="element-478" />
    </div>;
}